<template>
    <div class="elMYEk" v-if="dataOrder || order">
        <div class="ant-row xr33vl">
            <div class="ant-col ant-col-md-24 ant-col-lg-16 iterqw1">
                <div class="eYSGTX">Phương thức thanh toán</div>
                <small style="white-space: pre-line">
                  - Vào các ngày T6, T7, CN, T2, chỉ có thể chọn phương thức trả tiền mặt nếu đặt 1 vé
                  - Vào các ngày còn lại, có thển chọn phương thức trả tiền mặt nếu đặt 2 vé trở xuống
                </small>
                <div class="ticket-info-body bDsdiK" style="border: 1px solid rgb(192, 192, 192);">
                    <div class="ant-radio-group ant-radio-group-outline">
<!--                        <div class="ant-row ldLmqB">-->
<!--                            <label class="iYLSXm ant-radio-wrapper">-->
<!--                                <span class="ant-radio"-->
<!--                                      :class="{'ant-radio-checked': picked === paymentMethod.megapay}">-->
<!--                                    <input type="radio" class="ant-radio-input" id="zalo-pay"-->
<!--                                           :value="paymentMethod.megapay" v-model="picked">-->
<!--                                    <span class="ant-radio-inner"></span>-->
<!--                                </span>-->
<!--                                <span>-->
<!--                                    <img src="../../assets/images/qr-pc.svg" class="iPjKRT">-->
<!--                                    <span class="iPJkNa">Thanh toán Megapay</span>-->
<!--                                </span>-->
<!--                            </label>-->
<!--                            &lt;!&ndash;                            <div v-show="picked === paymentMethod.megapay" class="cXtbOj">&ndash;&gt;-->
<!--                            &lt;!&ndash;                                <div class="hjbjw2">&ndash;&gt;-->
<!--                            &lt;!&ndash;                                    <div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                                        <span class="GBtOq">Hướng dẫn thanh toán</span>&ndash;&gt;-->
<!--                            &lt;!&ndash;                                        <div class="MuhUt">&ndash;&gt;-->
<!--                            &lt;!&ndash;                                            1. Bạn sẽ đuợc chuyển đến cổng thanh toán ZaloPay&ndash;&gt;-->
<!--                            &lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                                        <div class="MuhUt">&ndash;&gt;-->
<!--                            &lt;!&ndash;                                            2. Mở ứng dụng Zalo, bấm nút Thanh toán và quét mã QR trên màn hình&ndash;&gt;-->
<!--                            &lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                                        <div class="MuhUt">&ndash;&gt;-->
<!--                            &lt;!&ndash;                                            3. Kiểm tra thông tin và bấm xác nhận Thanh toán&ndash;&gt;-->
<!--                            &lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                            </div>&ndash;&gt;-->
<!--                        </div>-->
                        <div class="ant-row ldLmqB">
                            <label class="iYLSXm ant-radio-wrapper" v-if="availablePaymentMethods.includes(paymentMethod.bank_transfer)">
                                <span class="ant-radio"
                                      :class="{'ant-radio-checked': picked === paymentMethod.bank_transfer}">
                                    <input type="radio" class="ant-radio-input" id="bank-transfer" v-model="picked"
                                           :value="paymentMethod.bank_transfer">
                                    <span class="ant-radio-inner"></span>
                                </span>
                                <span>
                                    <img src="../../../assets/images/atm-pc.svg" class="iPjKRT"/>
                                    <span class="iPJkNa">Chuyển khoản ngân hàng</span>
                                </span>
                            </label>
                          <label class="iYLSXm ant-radio-wrapper" v-if="availablePaymentMethods.includes(paymentMethod.cash)">
                                <span class="ant-radio"
                                      :class="{'ant-radio-checked': picked === paymentMethod.cash}">
                                    <input type="radio" class="ant-radio-input" id="cash" v-model="picked"
                                           :value="paymentMethod.cash">
                                    <span class="ant-radio-inner"></span>
                                </span>
                            <span>
                                    <img src="../../../assets/images/atm-pc.svg" class="iPjKRT"/>
                                    <span class="iPJkNa">Tiền mặt</span>
                                </span>
                          </label>
                            <!--                            <div v-show="picked === paymentMethod.bank_transfer" class="cXtbOj">-->
                            <!--                                <div class="hjbjw2">-->
                            <!--                                    <span class="GBtOq">Hướng dẫn thanh toán</span>-->
                            <!--                                    <div class="cMToPT">-->
                            <!--                                        <div class="ant-row">-->
                            <!--                                            <div class="ant-col ant-col-10 eZPgtX">-->
                            <!--                                                Số tài khoản-->
                            <!--                                            </div>-->
                            <!--                                            <div class="ant-col ant-col-14 bxRQOX">-->
                            <!--                                                1900 8999 0909 1234-->
                            <!--                                            </div>-->
                            <!--                                        </div>-->
                            <!--                                        <div class="ant-row">-->
                            <!--                                            <div class="ant-col ant-col-10 eZPgtX">-->
                            <!--                                                Chủ tài khoản-->
                            <!--                                            </div>-->
                            <!--                                            <div class="ant-col ant-col-14 bxRQOX">-->
                            <!--                                                Công ty TNHH Hoàng Công-->
                            <!--                                            </div>-->
                            <!--                                        </div>-->
                            <!--                                        <div class="ant-row">-->
                            <!--                                            <div class="ant-col ant-col-10 eZPgtX">-->
                            <!--                                                Chi nhánh-->
                            <!--                                            </div>-->
                            <!--                                            <div class="ant-col ant-col-14 bxRQOX">-->
                            <!--                                                Quảng Ninh-->
                            <!--                                            </div>-->
                            <!--                                        </div>-->
                            <!--                                        <div class="ant-row">-->
                            <!--                                            <div class="ant-col ant-col-10 eZPgtX">-->
                            <!--                                                Nội dung chuyển khoản-->
                            <!--                                            </div>-->
                            <!--                                            <div class="ant-col ant-col-14 bxRQOX">-->
                            <!--                                                0K17Q40 - {{getProp(order, 'customer.phone_number', '')}}-->
                            <!--                                            </div>-->
                            <!--                                        </div>-->
                            <!--                                    </div>-->
                            <!--                                    <div class="MuhUt"><b>Lưu-->
                            <!--                                        ý: </b>Vé của bạn chỉ đuợc giữ chỗ trong <b>60 phút</b>. Vui-->
                            <!--                                        lòng thanh toán, nếu không vé của bạn sẽ bị hủy-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                </div>
                <button type="button"
                        class="ant-btn jXicDs ant-btn-primary ant-btn-block mt-3 mb-5"
                        :disabled="isSubmitting"
                        @click.stop="payment">
                    <span>THANH TOÁN</span>
                </button>
            </div>
            <div class="ant-col ant-col-md-24 ant-col-lg-8 iterqw1">
                <div class="ant-row">
                    <div class="ftCfKZ">Thông tin chuyến đi</div>
                    <div class="iDsYIW">
                        <div class="ticket-info-body bAnCgx" style="height: 158px;">
                            <table class="table-info">
                                <tbody>
                                <tr>
                                    <td class="label mb-3">Hành khách</td>
                                    <td class="value mb-3">{{getProp(order, 'customer.name', '')}}</td>
                                </tr>
                                <tr>
                                    <td class="label">Số điện thoại</td>
                                    <td class="value">{{getProp(order, 'customer.phone_number', '')}}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div class="row-divider"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">Tuyến đường</td>
                                    <td class="value">
                                        {{getProp(order, 'schedule.voyage.from', '')}} - {{getProp(order, 'schedule.voyage.to', '')}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!--                <div class="ant-row" style="margin-top:24px">-->
                <!--                    <div style="text-align:left" class="ant-col ant-col-12">-->
                <!--                        <div class="eYSGTX">Tổng tiền</div>-->
                <!--                    </div>-->
                <!--                    <div style="text-align:right" class="ant-col ant-col-12">-->
                <!--                        <div class="htfpgU">250.000&nbsp;₫</div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="iDsYIW">
                    <div class="ticket-info-body bAnCgx"
                         style="height: 115px;">
                        <table class="table-info">
                            <tbody>
                            <tr>
                                <td class="label">Ghế:</td>
                                <td class="value">
                                    <div class="hybCQv">
                                        <div class="iRTCuR">{{getProp(order, 'seats', []).map(seat => getProp(seat, 'p_row', '') + '.' + getProp(seat, 'p_col', '')).join(', ')}}</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <div class="row-divider"></div>
                                </td>
                            </tr>
                            <tr>
                                <td class="label">Tổng tiền</td>
                                <td class="value">
                                    <div class="htfpgU">{{getProp(order, 'total_price_pretty', '')}}&nbsp;₫</div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div id="payment-container">

            </div>
        </div>
    </div>
</template>

<script>
    import {RepositoryFactory, MixinHelper, eventBus, EVENTS} from "../../shared/services";
    import $ from 'jquery';
    import {HCROUTES, PaymentMethod} from '../../shared/constants/Constant';
    import addMinutes from 'date-fns/addMinutes';

    const repoOrder = RepositoryFactory.get('orders');
    export default {
        name: "Payment",
        mixins: [MixinHelper],
        created() {
            this.windowTypeMegapay = (window.innerWidth < 767) ? 1 : 0;

            this.dataOrder = this.retrieveData('data_order');

            if (this.dataOrder) {
                this.order = this.convertToOrder(this.dataOrder);
            }
            const orderIdData = this.retrieveData('order_id');
            if (orderIdData && orderIdData.hasOwnProperty('value')) {
                this.removeDatas(['order_id', 'data_order']);
                this.$router.push({name: HCROUTES.payment, query: {order_id: orderIdData.value}});
                return;
            }

            this.order_id = this.getProp(this.$route.query, 'order_id', null);
            if (this.order_id) {
                this.singleOrder(this.order_id);
            }
            if (!this.dataOrder && !this.order_id) {
                eventBus.$emit(EVENTS.not_found);
            }
        },
        // mounted() {
        //     const self = this;
        //     window.addEventListener('message', function (e) {
        //         if (e.data.closeLayer == 'close') {
        //             //window.top.closeLayer();
        //             self.closeLayer();
        //         }
        //     });
        // },
        data() {
            return {
                order_id: null,
                order: null,
                picked: PaymentMethod.bank_transfer,
                paymentMethod: PaymentMethod,
                availablePaymentMethods: [],
                windowTypeMegapay: 0,
                dataOrder: null,
                isSubmitting: false
            }
        },
        methods: {
            singleOrder(order_id) {
                repoOrder.single(order_id)
                    .then(resp => {
                        this.order = this.getProp(resp, 'data.data', null);
                        if (!this.order) {
                            eventBus.$emit(EVENTS.not_found)
                        }
                    })
                    .catch(() => {
                        eventBus.$emit(EVENTS.not_found);
                    })
            },
            payment() {
                const self = this;
                this.isSubmitting = true;
                if (this.order_id) {
                    // const data = {...{}, order_id: this.order_id, payment_method: this.picked};
                    // repoOrder.takePaymentInfo(data)
                    //     .then(resp => {
                    //         const data = this.getProp(resp, 'data.data', {});
                    //         this.handlePaymentResp(data);
                    //     })
                    //     .catch(err => console.log(err))
                    //     .finally(function () {
                    //         setTimeout(function () {
                    //             self.isSubmitting = false;
                    //         }, 3000)
                    //     })
                    this.pushRoutePaymentResult();
                } else {
                    const data = {...this.getProp(this.dataOrder, 'formData', {}), payment_method: this.picked};
                    repoOrder.create(data)
                        .then(resp => {
                            this.order_id = this.getProp(resp, 'data.data.id', 0);
                            this.storeData('order_id', {...{}, value: this.order_id, expire: addMinutes(new Date(), 3).valueOf()});
                            this.removeData('data_order');
                            const data = this.getProp(resp, 'data.data', {});
                            this.handlePaymentResp(data);
                        })
                        // eslint-disable-next-line no-console
                        .catch(err => console.log(err))
                        .finally(function () {
                            setTimeout(function () {
                                self.isSubmitting = false;
                            }, 3000)
                        })
                }
            },
            handlePaymentResp(data) {
                if (this.picked === this.paymentMethod.megapay) {
                    this.createFormPayment(data);
                } else {
                    this.pushRoutePaymentResult();
                }
            },
            pushRoutePaymentResult() {
                this.$router.push({
                    name: HCROUTES.payment_result,
                    params: {order_id: this.order_id},
                    query: {payment_method: this.picked}
                });
            },
            convertToOrder(dataOrder) {
                return {
                    ...{},
                    customer: {
                        name: this.getProp(dataOrder, 'formData.customer_name', ''),
                        phone_number: this.getProp(dataOrder, 'formData.phone_number', ''),
                    },
                    seats: this.getProp(dataOrder, 'seats_preview', []),
                    total_price_pretty: this.getProp(dataOrder, 'totalPrice', 0).toLocaleString('us'),
                    schedule: {
                        voyage: {
                            from: this.getProp(dataOrder, 'schedule.voyage.from', ''),
                            to: this.getProp(dataOrder, 'schedule.voyage.to', ''),
                        }
                    },
                    schedule_id: this.getProp(dataOrder, 'schedule.id'),
                    total_tickets: this.getProp(dataOrder, 'formData.ticket_quantity', 0),
                }
            },
            createFormPayment(data) {
                var formData = this.getProp(data, 'megapay_formdata', {});

                var container = document.getElementById('payment-container');
                var megapayForm = document.getElementById('megapayForm');
                if (megapayForm) {
                    container.removeChild(megapayForm);
                }
                var form = document.createElement('form');
                form.setAttribute('id', 'megapayForm');
                form.setAttribute('name', 'megapayForm');
                form.setAttribute('method', 'POST');

                for (var k in formData) {
                    if (formData.hasOwnProperty(k)) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'hidden');
                        input.setAttribute('value', formData[k]);
                        input.setAttribute('name', k);

                        form.appendChild(input);
                    }
                }
                container.appendChild(form);
                var action = this.getProp(data, 'domain_megapay', '') + "/pg_was/order/Minit.do";
                form.setAttribute('action', action);
                if (this.windowTypeMegapay === 0) {
                    action = this.getProp(data, 'domain_megapay', '') + "/pg_was/order/init.do";
                    form.setAttribute('action', action);
                    this.init(form);
                }
                form.submit();
            },
            init(paymentForm) {

                var div_paymentLayer = document.getElementById('paymentLayer');
                if (div_paymentLayer == null || div_paymentLayer == undefined) {
                    var temp = document.createElement('div');
                    var innerData = '';
                    innerData = '<div id="paymentLayer" class="payment_layer">';
                    innerData += '<div class="payment_bg"></div>';
                    innerData += '<div id="payment_box" class="payment_pop_layer">';
                    innerData += '<div class="payment_pop_container">';
                    innerData += '<div class="payment_pop_conts">';
                    innerData += '<iframe name="paymentF" id="paymentF" width="100%" height="100%" marginWidth="0" marginHeight="0" frameBorder="0" scrolling="no" style="background-image: url(../images/progress.gif); background-repeat: no-repeat; background-position: center center;" ></iframe>';
                    innerData += '</div>';
                    innerData += '</div>';
                    innerData += '</div>';
                    innerData += '</div>';

                    temp.innerHTML = innerData;
                    paymentForm.appendChild(temp);

                }
                this.payment_open('payment_box');

                $("#paymentF").attr('src', $(paymentForm).attr("action"));
                $(paymentForm).attr("target", "paymentF");
            },
            payment_open(el) {
                // element = el;
                var payment_box = $('#' + el);
                var payment_bg = payment_box.prev().hasClass('payment_bg');

                if (payment_bg) {
                    $('.payment_layer').fadeIn();
                } else {
                    payment_box.fadeIn();
                }

                if (payment_box.outerHeight() < $(document).height()) payment_box.css('margin-top', '-' + payment_box.outerHeight() / 2 + 'px');
                else payment_box.css('top', '0px');
                if (payment_box.outerWidth() < $(document).width()) payment_box.css('margin-left', '-' + payment_box.outerWidth() / 2 + 'px');
                else payment_box.css('left', '0px');
            },
            closeLayer() {
                $('.payment_layer').fadeOut();
            }
        },
        beforeDestroy() {
            eventBus.$emit(EVENTS.off_not_found_page);
        },
        watch: {
          order(val) {
            if (val.total_tickets) {
              repoOrder.getPaymentMethods(val.total_tickets, val.schedule_id)
                  .then((res) => this.availablePaymentMethods = res.data.datas.map(v => v.toString()));
            }
          }
        }
    }
</script>

<style>
    .payment_layer {
        display: none;
        position: fixed;
        _position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
    }

    .payment_layer .payment_bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: .5;
        filter: alpha(opacity=50);
    }

    .payment_layer .payment_pop_layer {
        display: block;
    }

    .payment_pop_layer {
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 800px;
        height: 547px;
        background-color: #fff;
        z-index: 9999;
    }

    .payment_pop_layer .payment_pop_container {
        width: 100%;
        height: 100%;
        padding: 0px;
    }

    .payment_pop_conts {
        width: 100%;
        height: 100%;
        padding: 0px;
    }

    .payment_pop_layer_origin {
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 510px;
        height: auto;
        background-color: #fff;
        border: 5px solid #ff0d0d;
        z-index: 9999;
    }

    .setDiv {
        padding-top: 100px;
        text-align: center;
    }

    .mask {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9999;
        background-color: #000;
        display: none;
    }

    .window {
        display: none;
        background-color: #ffffff;
        height: 200px;
        z-index: 99999;
    }
</style>

<style scoped>
    .elMYEk {
        /*min-height: calc(100vh - 40px);*/
        width: 980px;
        padding-top: 50px;
        padding-bottom: 24px;
        margin: auto;
    }

    @media (max-width: 991px) {
        .elMYEk {
            width: 95%;
        }
    }

    .xr33vl {
        margin-left: -8px;
        margin-right: -8px;
        margin-top: 18px
    }

    .iterqw1 {
        padding-left: 8px;
        padding-right: 8px
    }

    .hjbjw2 {
        margin: 0px 0px 0px 25px;
        display: block;
        padding-top: 16px;
    }

    .eYSGTX {
        font-weight: 500;
        font-size: 18px;
        color: rgb(72, 72, 72);
    }

    .htfpgU {
        font-size: 18px;
        color: rgb(0, 96, 196);
        font-weight: bold;
    }

    .iPJkNa {
        font-size: 16px;
        font-weight: 600;
        color: rgb(72, 72, 72);
        padding-left: 10px;
    }

    .bDsdiK {
        position: relative;
        width: 100%;
        margin-top: 12px;
        height: auto;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(192, 192, 192);
        border-image: initial;
        border-radius: 4px;
        transition: all 0.3s linear 0s;
        overflow: hidden;
        background: white;
        padding: 0px 16px;
    }

    .iPjKRT {
        height: 20px;
        width: 25px;
    }

    .bDsdiK .ant-radio-group {
        width: 100%;
    }

    .ldLmqB {
        padding: 20px 0px;
        border-bottom: 1px solid rgb(227, 227, 227);
    }

    .iYLSXm {
        line-height: 20px;
    }

    .ldLmqB .ant-radio-wrapper {
        display: flex;
    }

    .bDsdiK .ant-collapse-content, .bDsdiK .ant-collapse-item, .bDsdiK .ant-collapse {
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        background: none;
    }

    .cXtbOj .ant-collapse-content-box {
        padding-top: 16px !important;
    }

    .bDsdiK .ant-collapse-content-box {
        padding: 0px;
    }

    .GBtOq {
        font-size: 16px;
        font-weight: bold;
    }

    .MuhUt {
        font-size: 16px;
        margin-top: 30px;
    }

    .ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
        border-radius: 0 0 4px 4px;
    }

    .ant-collapse-item:last-child > .ant-collapse-content {
        border-radius: 0 0 4px 4px;
    }

    .cMToPT {
        padding-top: 10px;
    }

    .eZPgtX {
        font-size: 16px;
        margin-top: 10px;
    }

    .bxRQOX {
        font-size: 16px;
        margin-top: 10px;
        font-weight: bold;
    }

    .ftCfKZ {
        font-weight: 500;
        font-size: 18px;
        color: rgb(72, 72, 72);
    }

    .iDsYIW {
        word-break: break-word;
        position: relative;
        width: 100%;
        margin-top: 12px;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(192, 192, 192);
        border-image: initial;
        border-radius: 4px;
    }

    .bAnCgx {
        height: auto;
        transition: all 0.3s linear 0s;
        overflow: hidden;
        background: white;
        padding: 12px 16px 0px;
    }

    .iDsYIW .ticket-info-body {
        height: auto !important;
        padding: 20px;
        background: none;
    }

    .bAnCgx .table-info {
        width: 100%;
    }

    .iDsYIW .label {
        padding-right: 2px;
        font-size: 16px !important;
    }

    .bAnCgx .table-info .label {
        font-weight: bold;
        width: 25%;
        font-size: 13px;
        color: rgb(72, 72, 72);
        vertical-align: top;
        white-space: nowrap;
    }

    .iDsYIW .value {
        text-align: right;
        font-size: 16px !important;
    }

    .bAnCgx .table-info .value {
        font-size: 14px;
        color: rgb(0, 0, 0);
        vertical-align: top;
    }

    .bAnCgx .table-info .row-divider {
        height: 1px;
        background: rgb(227, 227, 227);
        margin: 8px 0px;
    }

    .hybCQv {
        margin-bottom: 10px;
    }

    .bAnCgx .table-info {
        background-color: #fff;
    }

    .jXicDs {
        background-color: #ffc500;
        border: 0;
    }

</style>
